import { axios } from '~/common/utils/request'
const commonPath = 'rest/store/general/v3/'

// 设置下政策列表&应用详情下政策页签
export const getRuleSetList = (url,params) => axios({
  url: `${commonPath}${url}`,
  method: 'post',
  data: params
})
// 政策详情下规则页签列表
export const policyTabRuleList = params => axios({
  url: `${commonPath}policy_instance/query_rule`,
  method: 'post',
  data: params
})

// 政策详情
export const ruleSetPolicyDetail = id => axios({
  url: `${commonPath}policy_instance/detail/${id}`,
  method: 'get'
})
// 应用列表接口
export const ruleSetAppList = params => axios({
  url: `${commonPath}policy_instance/query_set`,
  method: 'post',
  data: params
})
// 应用下二级抽屉规则页签设置（update）
export const ruleSetPolicyTabRuleUpdate = params => axios({
  url: `${commonPath}policy_instance/rule_set`,
  method: 'post',
  data: params
})



